<template>
  <div class="core">
    <div class="layui-fluid repair-statistics-tabs">
      <el-tabs :tab-position="tabPosition">
        <el-tab-pane label="故障每月变化趋势">
          <lineStatistics :lineData="lineData" />
        </el-tab-pane>
        <el-tab-pane label="故障类型图表">
          <pieStatistics :pieData="pieData" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import '../../../utils/map/css/core.css'
import request from '@/network/networkconfig'
import lineStatistics from '@/components/repairs/repairStatistics/lineStatistics'
import pieStatistics from '@/components/repairs/repairStatistics/pieStatistics'

export default {
  name: 'statisticsCharts',
  components: {
    lineStatistics,
    pieStatistics,
  },
  data() {
    return {
      activeTabName: 'first',
      tabPosition: 'left',
      lineData: [],
      pieData: [],
    }
  },
  props: {
    monthRepairVOList: {
      type: Array,
      default: () => {
        return []
      },
    },
    repairStatisticsChartPieHelpVOList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  mounted() {
    this.lineData = this.monthRepairVOList
    this.pieData = this.repairStatisticsChartPieHelpVOList
  },
  watch: {
    monthRepairVOList(value) {
      this.lineData = value
    },
    repairStatisticsChartPieHelpVOList(value) {
      this.pieData = value
    },
  },
  methods: {},
}
</script>

<style scoped>
.repair-statistics-tabs {
  background-color: white;
}
</style>




// WEBPACK FOOTER //
// src/components/repairs/repairStatistics/statisticsCharts.vue